import { render, staticRenderFns } from "./QrcodeDropZone.vue?vue&type=template&id=bc63af7c&lang=html&"
import script from "./QrcodeDropZone.vue?vue&type=script&lang=js&"
export * from "./QrcodeDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports